/**
 * Slider Component
 *
 */
class sliderElement extends HTMLElement{
    constructor() {
      super();
      this.sliderEle = this.querySelector('.swiper-slider');
      this.sliderOptions = JSON.parse(this.sliderEle.getAttribute('data-slider'));
    }
  
    static get observedAttributes() {
      return ["data-slider"];
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "data-slider" && newValue) {
        this.sliderOptions = JSON.parse(newValue);
      }
    }
  
    connectedCallback() {
      if(!this.sliderEle) return;
      
      let thumbSlider = null;
  
      // Set up nav slider 
      if(this.sliderEle.hasAttribute('data-nav')){
        thumbSlider = document.querySelector(`.${this.sliderEle.getAttribute('data-nav')}`);
        if(!thumbSlider){
          return;
        }
  
        const thumbSliderOptions = JSON.parse(thumbSlider.getAttribute('data-slider'));
        thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);
        
        this.sliderOptions.thumbs = {
          swiper: thumbSlider
        }
      }
  
      const sliderInstance = new Swiper(this.sliderEle, this.sliderOptions);
      this.instance = sliderInstance;
      this.slideChangeEvt(sliderInstance, thumbSlider);
    }
  
    slideChangeEvt(slider, thumbSlider){
      slider.on('slideChange', () => {
        if(thumbSlider) thumbSlider.slideTo(slider.activeIndex);
  
        const activeVideos = slider.el.querySelectorAll(".custom-video-container.playing--video");
        if(activeVideos.length > 0){
          activeVideos.forEach((container)=>{
            const video = container.querySelector('custom-video');
            const videoEle = video.querySelector('video') || video.querySelector('iframe');
            if(video.getAttribute('data-video-type') == 'local'){
              videoEle.pause();
            }else if(video.getAttribute('data-video-type') == 'youtube'){
              videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
          });
        }
      });
    }
}
customElements.define('slider-element', sliderElement);
